import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=88e1f38e&"
import script from "./ModalComponent.vue?vue&type=script&lang=ts&"
export * from "./ModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e1f38e')) {
      api.createRecord('88e1f38e', component.options)
    } else {
      api.reload('88e1f38e', component.options)
    }
    module.hot.accept("./ModalComponent.vue?vue&type=template&id=88e1f38e&", function () {
      api.rerender('88e1f38e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ModalComponent.vue"
export default component.exports